<template>
  <div v-if="order" class="card-deck row" id="order-information">
    <div class="card col-md-7 border-0 shadow-sm mb-4">
      <div class="card-body">

        <div class="row">
          <div class="col-4 text-right">Date</div>
          <div class="col-8">{{ order.date | formatDateTime }}</div>
        </div>
        <div class="row">
          <div class="col-4 text-right">Source / Channel</div>
          <div class="col-8"><i :class="order.source.icon"></i>
            {{ order.source.name }}
            <span v-if="order.channel">/ {{ order.channel.name }}</span>
          </div>
        </div>
        <div v-if="order.added_by_user" class="row">
          <div class="col-4 text-right">Added By</div>
          <div class="col-8">
            {{ order.added_by_user.name }}
            <span class="small text-muted">{{ order.added_by_user.email }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-right">Total</div>
          <div class="col-8">
            <strong>{{ order.total | numberToRs }}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-right">Payment Method</div>
          <div class="col-8">
            <template v-if="order.payment_method">
              {{ order.payment_method.name }}
              <span class="small text-muted" v-if="order.payment_method.source">{{ order.payment_method.source }}</span>
            </template>
            <span v-else class="text-muted">-</span>
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-right">Payment Status</div>
          <div :class="'col-8 ' + order.payment_status.class">
            <i :class="order.payment_status.icon"></i>
            {{ order.payment_status.name }}
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-right">Order Status</div>
          <div :class="'col-8 ' + order.order_status.class">
            <i :class="order.order_status.icon"></i>
            {{ order.order_status.name }}
          </div>
        </div>

      </div>
    </div>

    <div class="card col-md-5 border-0 shadow-sm mb-4">
      <div class="card-body">

        <div class="row">
          <div class="col-4 text-right">Customer</div>
          <div class="col-8">
            <strong>{{ order.name }}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-right">Telephone</div>
          <div class="col-8">
            <template v-if="order.telephone">{{ order.telephone }}</template>
            <span v-else class="small text-muted font-italic">Not specified</span>
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-right">E-mail</div>
          <div class="col-8">
            <template v-if="order.email">{{ order.email }}</template>
            <span v-else class="small text-muted font-italic">Not specified</span>
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-right">Address</div>
          <div class="col-8">
            <template v-if="order.address_1">{{ order.address_1 }}</template>
            <span v-else class="small text-muted font-italic">Not specified</span>
            <template v-if="order.address_2">
              &middot; {{ order.address_2 }}
            </template>
          </div>
        </div>
        <div class="row">
          <div class="col-4 text-right">City</div>
          <div class="col-8">{{ order.city }}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderInformation',
  props: ['order']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/order/partials/Information.vue